module.exports = __webpack_public_path__ + "static/media/precis.6d56808e.mp3";